import e1 from '../assets/emojis/1.png'
import e2 from '../assets/emojis/2.png'
import e3 from '../assets/emojis/3.png'
import e4 from '../assets/emojis/4.png'
import e5 from '../assets/emojis/5.png'
import e6 from '../assets/emojis/6.png'
import e7 from '../assets/emojis/7.png'
import e8 from '../assets/emojis/8.png'
import e9 from '../assets/emojis/9.png'
import e10 from '../assets/emojis/10.png'
import e11 from '../assets/emojis/11.png'
import e12 from '../assets/emojis/12.png'
import e13 from '../assets/emojis/13.png'
import e14 from '../assets/emojis/14.png'
import e15 from '../assets/emojis/15.png'
import e16 from '../assets/emojis/16.png'
import e17 from '../assets/emojis/17.png'
import e18 from '../assets/emojis/18.png'
import e19 from '../assets/emojis/19.png'
import e20 from '../assets/emojis/20.png'
import e21 from '../assets/emojis/21.png'
import e22 from '../assets/emojis/22.png'
import e23 from '../assets/emojis/23.png'
import e24 from '../assets/emojis/24.png'
import e25 from '../assets/emojis/25.png'
import e26 from '../assets/emojis/26.png'
import e27 from '../assets/emojis/27.png'
import e28 from '../assets/emojis/28.png'
import e29 from '../assets/emojis/29.png'
import e30 from '../assets/emojis/30.png'
import e31 from '../assets/emojis/31.png'
import e32 from '../assets/emojis/32.png'
import e33 from '../assets/emojis/33.png'
import e34 from '../assets/emojis/34.png'
import e35 from '../assets/emojis/35.png'
import e36 from '../assets/emojis/36.png'
import e37 from '../assets/emojis/37.png'
import e38 from '../assets/emojis/38.png'
import e39 from '../assets/emojis/39.png'
import e40 from '../assets/emojis/40.png'
import e41 from '../assets/emojis/41.png'
import e42 from '../assets/emojis/42.png'
import e43 from '../assets/emojis/43.png'
import e44 from '../assets/emojis/44.png'
import e45 from '../assets/emojis/45.png'
import e46 from '../assets/emojis/46.png'
import e47 from '../assets/emojis/47.png'
import e48 from '../assets/emojis/48.png'


const typeIcons = [
  null,
  e1,
  e2,
  e3,
  e4,
  e5,
  e6,
  e7,
  e8,
  e9,
  e10,
  e11,
  e12,
  e13,
  e14,
  e15,
  e16,
  e17,
  e18,
  e19,
  e20,
  e21,
  e22,
  e23,
  e24,
  e25,
  e26,
  e27,
  e28,
  e29,
  e30,
  e31,
  e32,
  e33,
  e34,
  e35,
  e36,
  e37,
  e38,
  e39,
  e40,
  e41,
  e42,
  e43,
  e44,
  e45,
  e46,
  e47,
  e48
]

export default typeIcons